import { __awaiter } from 'tslib';
import { ContextClassBase, ServiceIdentity } from '../../core/service/RuntimeContext.js';
import 'long';
import '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import { Monitor, MonitorItem } from '../../core/metrics/monitor.js';
import '../../core/network/NetworkItem.js';
import { Subject } from '../../core/events/Subject.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../manager/AdapterManager.js';
import '../manager/types.js';
import '../../core/utils/ticker.js';
import './IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

var FileType;
(function (FileType) {
    FileType["Image"] = "image";
    FileType["Video"] = "video";
    FileType["Audio"] = "audio";
    FileType["CommonFile"] = "object";
})(FileType || (FileType = {}));
var MediaUploaderMonitorItem;
(function (MediaUploaderMonitorItem) {
    MediaUploaderMonitorItem["Uploader"] = "multimedia.uploader";
})(MediaUploaderMonitorItem || (MediaUploaderMonitorItem = {}));
class IMMediaUploader extends ContextClassBase {
    constructor(ctx, options) {
        super(ctx);
        this.onComplete = new Subject(ctx);
        this.onFail = new Subject(ctx);
        this.options = options;
    }
    performAddFile(file) {
        this.fileOption = this.addFile(file);
        return this.fileOption;
    }
    performUpload() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const startTime = Monitor.performanceNow();
            try {
                const result = yield this.upload();
                this.resolve(ServiceIdentity.Monitor).emitDuration(MediaUploaderMonitorItem.Uploader + MonitorItem.SuccessSuffix, startTime, {
                    type: (_a = this.fileOption.rawType) !== null && _a !== void 0 ? _a : 'unknown'
                });
                return result;
            }
            catch (err) {
                this.resolve(ServiceIdentity.Monitor).emitDuration(MediaUploaderMonitorItem.Uploader + MonitorItem.ErrorSuffix, startTime, {
                    type: (_b = this.fileOption.rawType) !== null && _b !== void 0 ? _b : 'unknown'
                });
                throw err;
            }
        });
    }
    genOption(file) {
        return {
            file: file.fileHandler,
            path: file.filePath,
            stsToken: this.options.stsToken,
            size: file.fileSize,
            rawType: file.type,
            type: file.type === FileType.Audio ? FileType.Video : file.type
        };
    }
}

export { IMMediaUploader, MediaUploaderMonitorItem };
//# sourceMappingURL=IMMediaUploader.js.map
